import * as React from 'react';
import Modal from 'antd/lib/modal/Modal';
import Skeleton from 'antd/lib/skeleton';
import { IDialogBranchProps } from './DialogBranch';
import List from 'antd/lib/list';
import { IAccount } from '../../Models/Account';
import { Branch } from '../../Models/Report';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import './DialogBranch.scss';

export interface IDialogBranchProps {
	open: boolean;
	toggle: () => void;
	current?: IAccount;
	loading: boolean;
}

const DialogBranch = (props: IDialogBranchProps) => (<Modal footer={false} className="DialogBranch" onCancel={props.toggle} width={600} visible={props.open} title="Faenas Asignadas">
	<Skeleton loading={props.loading || !props.current} active >
		<Row justify="space-between" type="flex" gutter={12}>
			{props.current && props.current.producers && props.current!.producers!.map(p =><Col>
				<List
					header={<h4>{p.name}</h4>}
					dataSource={p.branchs}
					renderItem={(item: Branch) => <List.Item>
						- {item.name}
					</List.Item>}
				/>
			</Col>)
			}
		</Row>
	</Skeleton>
</Modal>)

export default DialogBranch;
